module.exports = __webpack_public_path__ + "static/monei_pay_2-845a85e13d946943f2103b2f4053b9a9.png";